import { render, staticRenderFns } from "./vRegCapacitacion.vue?vue&type=template&id=cc87784c&scoped=true&"
import script from "./vRegCapacitacion.vue?vue&type=script&lang=js&"
export * from "./vRegCapacitacion.vue?vue&type=script&lang=js&"
import style0 from "./vRegCapacitacion.vue?vue&type=style&index=0&id=cc87784c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc87784c",
  null
  
)

export default component.exports